import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from '../../environments/environment';
import { first } from 'rxjs/operators';
import firebase from 'firebase';
import { FestivalUserService } from './festival-user-service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  currentUser: any;
  currentUserId: string | null = null; 

  app;

  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    private festivalUserService: FestivalUserService
  ) { }

  /**
   * Initiate the login process for this user
   * @param email email of the user
   */
  public async loginInit(email: string, password: string) {
    const credential = await this.afAuth.signInWithEmailAndPassword (email, password);
    return credential.user.uid;
  }

  public async createFirebaseUser(email: string, password: string) {
    if (!this.app) {
      this.app = firebase.initializeApp(environment.firebase, 'userCreationApp');
    }
    
    const credential = await this.app.auth().createUserWithEmailAndPassword(email, password);
    return credential.user;
  }

  /**
   * Initiate the password reset process for this user
   * @param email email of the user
   */
  public resetPasswordInit(email: string) {
    return this.afAuth.sendPasswordResetEmail(email, { url: environment.authUrl });
  }

  public getCurrentUser() {
    return this.afAuth.authState;
  }

  public getLoggedInUser() {
    this.currentUser = this.afAuth.authState.pipe(first()).toPromise();
    this.currentUserId = this.currentUser.uid;
  }

  public async signOut() {
    this.festivalUserService.SetCurrentFestivalUser(null);
    this.afAuth.signOut().then(() => {
      this.router.navigate(['']);
    });
  }
}
